module.exports = __webpack_public_path__ + "static/media/bot_no_bg.88efcfd9.png";